import { cn } from "../../lib/cn";

const variants = {
  default:
    "bg-foreground text-background hover:bg-foreground/90 border border-transparent",
  brand:
    "bg-brand text-white hover:bg-brand/90 border border-transparent",
  secondary:
    "bg-card text-foreground border border-border hover:bg-muted",
  ghost: "bg-transparent text-muted-foreground hover:bg-muted hover:text-foreground border border-transparent",
  outline:
    "bg-transparent text-foreground border border-border hover:bg-muted",
};

const sizes = {
  sm: "h-8 px-3 text-xs",
  md: "h-9 px-4 text-sm",
  lg: "h-10 px-5 text-sm",
};

export function Button({
  className,
  variant = "default",
  size = "md",
  children,
  ...props
}) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-60",
        variants[variant] || variants.default,
        sizes[size] || sizes.md,
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
